import axios from "axios";
import { service_url, cookieValue, URLJoin } from "./const";

async function RestPost(route_path, body, addon) {
  let full_url = URLJoin(service_url, route_path);
  if (addon === undefined) {
    addon = "/";
  }
  const config = {
    headers: {
      cookie: cookieValue,
      "Content-Type": "application/json",
    },
  };
  const { data } = await axios.post(full_url + addon, body, config);
  return data;
}

export default RestPost;

export async function RestPosMultiPartFile(route_path, body) {
  let full_url = URLJoin(service_url, route_path);

  const config = {
    headers: {
      cookie: cookieValue,
      "Content-Type": null,
    },
  };
  const { data } = await axios.post(full_url, body, config);
  return data;
}
